import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ShareService {
  private templateText = new Subject<string>();
  private sendDropZoneArray = new Subject<any>();
  private clearDropZone = new Subject<any>();
  private tabActive = new Subject<any>();
  private isTabsContentRendered = new BehaviorSubject<any>(1);
  private isActive = new Subject<any>();
  private saveTemplate = new Subject<any>();
  private triggerDashboardService = new Subject();

  _templateText = this.templateText.asObservable();
  _sendDropZoneArray = this.sendDropZoneArray.asObservable();
  _clearDropZone = this.clearDropZone.asObservable();
  _tabActive = this.tabActive.asObservable();
  _isTabsContentRendered = this.isTabsContentRendered.asObservable();
  _isActive = this.isActive.asObservable();
  _saveTamplate = this.saveTemplate.asObservable();
  _triggerDashboardService = this.triggerDashboardService.asObservable();

  constructor() {}

  send(data: string) {
    this.templateText.next(data);
  }

  save() {
    this.saveTemplate.next();
  }

  sendDrop(data: any) {
    this.sendDropZoneArray.next(data);
  }

  clear(data: any) {
    this.clearDropZone.next(data);
  }

  sendActiveTab(data: any) {
    this.tabActive.next(data);
  }

  sendTabsState(data: any) {
    this.isTabsContentRendered.next(data);
  }

  sendOnlyActive(data: any) {
    this.isActive.next(data);
  }

  sendDashboardDataRequest(data: boolean) {
    this.triggerDashboardService.next(data);
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/services/share.service.ts